import * as tslib_1 from "tslib";
var UploadCandidateDocumentController = /** @class */ (function () {
    /*@ngInject*/
    function UploadCandidateDocumentController($scope, $rootScope, $timeout, alertsAndNotificationsService, userService, documentService, MESSAGECONSTANTS, documentActionService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.userService = userService;
        this.documentService = documentService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.documentActionService = documentActionService;
        Dropzone.autoDiscover = false; // disable dropdown instantiation done in the plugin
    }
    UploadCandidateDocumentController.prototype.$onInit = function () {
        var _this = this;
        this.userId = this.$rootScope.userDetails.id;
        this.isEdit = this.document.id ? true : false;
        if (this.share === undefined) {
            this.share = false;
        }
        else {
            this.document.shared = true;
        }
        this.hideShare = (!this.share && !this.showUpload) || (this.showUpload && !this.isSharedDocumentActionAvailable);
        this.showUploadWizard = !this.isEdit;
        this.uploadClicked = false;
        this.initVariables();
        this.getCompaniesToShareCandidateDocuments();
        this.documentList = [];
        // wait for changes to take effect and then create wizard
        this.$timeout(function () {
            //initialize the drop zone configuration
            _this.documentUploadDropzone = _this.createDocumentUploadDropZone();
            // if(this.isEdit) {
            //     this._setFileInUploadDropZone(this.document.name, 10);
            // }
        }, 200);
        this.originalSharedEntityIds = this.document ? _.cloneDeep(this.document.sharedEntityIds) : "";
    };
    UploadCandidateDocumentController.prototype._setFileInUploadDropZone = function (fileName, fileSize) {
        var mockFile = {
            name: fileName,
            size: fileSize
        };
        this.documentUploadDropzone.options.addedfile.call(this.documentUploadDropzone, mockFile);
        // delete the DOM for 'remove button' option from the file in drop zone since job is now in 'open' status
        // find the remove button in the drop zone and delete it.
        $('.dz-remove').remove();
        // find the progress bar in the drop zone and delete it.
        $('.dz-progress').remove();
        // add the success tick mark onto the file
        $('.dz-file-preview.dz-preview').addClass('dz-success');
    };
    UploadCandidateDocumentController.prototype.initVariables = function () {
        this.documentList = [];
        this.companiesToShare = [];
        this.selectedCompaniesToShare = [];
        this.uploadResumesResponse = null;
        // flags
        this.disableUploadButtonFlag = true;
        this.fileExistsFlag = false;
        this.fileUploadInProgressFlag = false;
    };
    UploadCandidateDocumentController.prototype.getCompaniesToShareCandidateDocuments = function () {
        var _this = this;
        this.companiesToShare = this.companiesToShareCandidateDocuments ? tslib_1.__spread(this.companiesToShareCandidateDocuments) : [];
        this.companiesToShare.map(function (company) { return company.selected = false; });
        if (this.companiesToShare) {
            this.companiesToShare.forEach(function (company) {
                if (_this.document.sharedEntityIds.includes(company.id)) {
                    company.selected = true;
                    _this.selectedCompaniesToShare.push(company);
                }
            });
        }
    };
    /**
     * creates the resume upload drop zone.
     */
    UploadCandidateDocumentController.prototype.createDocumentUploadDropZone = function () {
        var _this = this;
        var dropZoneSettings = this._getDropZoneSettings();
        var documentUploadDropzone = new Dropzone("form#documentUploadDropzone", dropZoneSettings);
        // add event handlers for the drop zone
        documentUploadDropzone.on('addedfile', function (file, response) {
            _this.fileExistsFlag = true;
            _this.disableUploadButtonFlag = false;
            $('.dz-progress').css({ top: '70%' });
        });
        documentUploadDropzone.on('removedfile', function (file, response) {
            _this.fileExistsFlag = false;
            _this.disableUploadButtonFlag = true;
            _this.fileUploadInProgressFlag = false;
        });
        documentUploadDropzone.on('sendingmultiple', function (file, xhr, formData) {
            // disable the upload button to avoid multiple clicks
            _this.disableUploadButtonFlag = true;
            // indicate that file upload is in progress
            _this.fileUploadInProgressFlag = true;
            var sharedEntityIds = _this.document.shared ? _this.document.sharedEntityIds.join(",") : null;
            if (_this.document.id) {
                formData.append('documentId', _this.document.id);
            }
            formData.append('companyId', _this.document.companyId);
            formData.append('candidateId', _this.document.candidateId);
            formData.append('internalNote', _this.document.internalNote);
            formData.append('sharedEntityIds', sharedEntityIds);
            formData.append('shareDocument', _this.document.shared);
            formData.append('folderId', _this.document.folderId);
            formData.append('candidateType', _this.candidateType);
            formData.append('userId', _this.userId);
            if (_this.candidateDetails.jobMatchId) {
                formData.append('jobMatchId', _this.candidateDetails.jobMatchId);
            }
        });
        documentUploadDropzone.on('successmultiple', function (fileArray, response) {
            // remove file upload in progress flag
            _this.fileUploadInProgressFlag = false;
            _this.disableUploadButtonFlag = true;
            _this.uploadResumesResponse = response;
            if (angular.isDefined(response.files) && response.files.length > 0) {
                _this.documentList = tslib_1.__spread(response.files);
            }
            // disable adding of further files
            $(".dz-hidden-input").prop("disabled", true);
            _this.alertsAndNotificationsService.showBannerMessage("Document(s) uploaded successfully.", "success");
            if (_this.saveCallback) {
                _this.saveCallback();
            }
        });
        documentUploadDropzone.on("error", function (file, error) {
            _this.fileUploadInProgressFlag = false;
            var elements = document.querySelectorAll(".dz-file-preview");
            angular.forEach(elements, function (element, index) {
                var filename = element.querySelectorAll(".dz-filename span")[0].textContent;
                var errorMessage = element.querySelectorAll(".dz-error-message span")[0];
                if (filename === file.name) {
                    errorMessage.textContent = error.message == undefined ? error : error.message;
                }
            });
        });
        return documentUploadDropzone;
    };
    UploadCandidateDocumentController.prototype._getDropZoneSettings = function () {
        var dropZoneSettings = {};
        var maxFilesToUpload = 100;
        dropZoneSettings = {
            url: this.documentService.getUploadUrl(),
            paramName: function () {
                return "files";
            },
            acceptedFiles: ".pdf,.xlsx,.docx,.doc",
            maxFiles: maxFilesToUpload,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            timeout: 300000,
            addRemoveLinks: true,
            autoProcessQueue: false,
            uploadMultiple: true,
            parallelUploads: 100
        };
        return dropZoneSettings;
    };
    UploadCandidateDocumentController.prototype.onCompanyToShareSelected = function () {
        if (this.selectedCompaniesToShare && this.selectedCompaniesToShare.length > 0) {
            var sharedEntityIds_1 = [];
            angular.forEach(this.selectedCompaniesToShare, function (company, key) {
                sharedEntityIds_1.push(company.id);
            });
            this.document.sharedEntityIds = sharedEntityIds_1.toString();
        }
    };
    UploadCandidateDocumentController.prototype.updateDocumentData = function () {
        var _this = this;
        if (this._isDataValid()) {
            this.document.shareDocument = this.document.shared;
            this.document.documentId = this.document.id;
            if (this.originalSharedEntityIds && this.originalSharedEntityIds.length > 0) {
                var unSharedEntityIds_1 = [];
                this.originalSharedEntityIds.map(function (company) {
                    if (!_this.document.sharedEntityIds.includes(company)) {
                        unSharedEntityIds_1.push(company);
                    }
                });
                this.document.unSharedEntityIds = unSharedEntityIds_1.toString();
            }
            this.document.sharedEntityIds = this.document.shared ? this.document.sharedEntityIds.join(",") : null;
            this.document.candidateType = this.candidateType;
            this.document.userId = this.userId;
            this.documentActionService.setParentAndChildFolderName(this.allFolders, this.document);
            if (this.candidateDetails.jobMatchId) {
                this.document.jobMatchId = this.candidateDetails.jobMatchId;
            }
            this.documentService.updateCandidateDocumentData(this.document, function (data) {
                var message = _this.share ? "Document shared successfully." : "Document updated successfully.";
                _this.alertsAndNotificationsService.showBannerMessage(message, "success");
                if (_this.saveCallback) {
                    _this.saveCallback();
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
            });
        }
    };
    UploadCandidateDocumentController.prototype.uploadDocument = function () {
        this.uploadClicked = true;
        // if(!this.uploadDocumentForm.$invalid) {
        if (this._isDataValid()) {
            this.documentUploadDropzone.processQueue();
        }
        // }
    };
    UploadCandidateDocumentController.prototype._isDataValid = function () {
        this.document.sharedEntityIds = this.selectedCompaniesToShare.map(function (company) { return company.id; });
        return !this.document.shared || (this.document.shared && this.document.sharedEntityIds.length >= 0);
    };
    UploadCandidateDocumentController.prototype.removeAllSelectedCompanies = function () {
        this.companiesToShare.forEach(function (company) {
            company.selected = false;
        });
        this.selectedCompaniesToShare = [];
        this.document.sharedEntityIds = "";
    };
    UploadCandidateDocumentController.prototype.receiveFormalizedComment = function (event) {
        this.document.internalNote = event;
    };
    UploadCandidateDocumentController.prototype.onVoiceTranscript = function (transcript) {
        if (this.document.internalNote) {
            this.document.internalNote += ' ' + transcript;
        }
        else {
            this.document.internalNote = transcript;
        }
    };
    return UploadCandidateDocumentController;
}());
UploadCandidateDocumentController.$inject = ['$scope', '$rootScope', '$timeout', 'alertsAndNotificationsService', 'userService', 'documentService', 'MESSAGECONSTANTS', 'documentActionService'];
// import * as TEMPLATE from './upload-candidate-document.html';
import * as TEMPLATE from 'raw-loader!./upload-candidate-document.html';
export var UploadCandidateDocumentComponent = {
    selector: 'uploadCandidateDocument',
    component: {
        bindings: {
            document: '<',
            showUpload: '<',
            share: '<',
            candidateType: '<',
            candidateDetails: '<',
            cancelCallback: '&',
            saveCallback: '&',
            controlObject: '=',
            allFolders: '<',
            isSharedDocumentActionAvailable: '<',
            companiesToShareCandidateDocuments: '<',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: UploadCandidateDocumentController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/uploadCandidateDocument/upload-candidate-document.html'
    }
};
//# sourceMappingURL=upload-candidate-document.component.js.map